export const copy = (val) => {
  if (val === undefined) {
    console.warn("copy对象为undefined");
  } else {
    return JSON.parse(JSON.stringify(val));
  }
};

function isObject(obj) {
  //判断是否为对象
  let type = Object.prototype.toString.call(obj);
  if (type === "[object Object]") {
    return true;
  }
}
export function debounce(func, wait, options) {
  //声明参数
  let lastArgs, //上次调用参数
    lastThis, //上次调用this
    maxWait, //最大等待时间
    result, //返回结果
    timerId,
    lastCallTime; //上次调用debounced时间，即出发时间，不一定会调用func

  //参数初始化let
  let lastInvokeTime = 0; //上次调用func时间，即成功执行时间
  let leading = false; //是否在超时之前调用
  let maxing = false; //是否传入最大超时时间
  let trailing = true; //是否超时之后调用

  if (typeof func !== "function") {
    throw new TypeError("debounce的第一个参数类型为funtion");
  }

  wait = +wait || 0;
  //+wait 作用就是转变wait的数据类型，变成Number类型 传入的执行时间间隔
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = options.maxWait;
    maxWait = options.maxWait
      ? Math.max(Number(options.maxWait) || 0, wait)
      : maxWait;
    trailing = !!options.trailing || trailing;
  }

  function invokeFunc(time) {
    //调用function 参数为当前时间
    let args = lastArgs;
    let thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time; //将上次调用时间重置为当前时间
    result = func.apply(thisArg, args); //执行传入
    return result;
  }

  function leadingEdge(time) {
    //超时之前调用
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait); //开始timer 为trailing Edge触发函数调用设定定时器 如果leading为 true 后续执行条件不满足就不会执行func
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    //设置还需要等待的时间
    const timeSinceLastCall = time - lastCallTime, //距离上次debounced函数被调用的时间
      timeSinceLastInvoke = time - lastInvokeTime, //距离上次func函数被执行的时间
      result = wait - timeSinceLastCall; //还需要等待的时间 计算出下一次trailing的位置
    //maxing就是options.maxWait  两种情况
    // 设置了maxing 比较下一次maxing和下一次trailing的最小值，作为下一次函数要执行的时间
    //无max 在下一次trailing时执行 timerExpired
    return maxing ? Math.min(result, maxWait - timeSinceLastInvoke) : result;
  }

  //根据时间判断func能否被执行
  function shouldInvoke(time) {
    //是否应该被调用
    const timeSinceLastCall = time - lastCallTime, //距离上次触发时间的时间
      timeSinceLastInvoke = time - lastInvokeTime; //距离上次调用func的时间
    return (
      lastCallTime === undefined || //从未执行过也就是首次调用
      timeSinceLastCall >= wait || //距离上次被调用的时间超过了wait的时间
      timeSinceLastCall < 0 || //系统时间倒退？？
      (maxing && timeSinceLastInvoke >= maxWait)
    ); //超过最大等待时间
  }

  function timerExpired() {
    //定时器的回调函数 用来判断是否执行func
    const time = Date.now();
    //在 options.trailing  edge且时间符合条件时候 调用trailingEdge函数，否则重启定时器
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    //重启定时器 保证下一次时延的末尾触发
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    //超时之后被调用 trailing = true;options里声明的变量默认为 true
    timerId = undefined;
    //有lastArgs才执行，意味着只有func已经被debounced过一次以后才会在trailing edge执行
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancle() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(Date.now());
  }

  function debounced(...args) {
    const time = Date.now(), //获取到当前的时间
      isInvoking = shouldInvoke(time); //判断是否可以调用
    lastArgs = args;
    lastThis = this;
    lastCallTime = time; //Date.now()
    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }

    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancle;
  debounced.flush = flush;
  return debounced;
}

export function getCookie(name) {
  const cookies = document.cookie.split("; ");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].split("=");
    if (cookie[0] === name) {
      return cookie[1];
    }
  }
  return "";
}

export function getImage(src) {
  // if (src.indexOf("/eventProductApi/") === 0) {
  //     return src.replace("/eventProductApi/", "/api/");
  // } else {
  //     return src;
  // }
  return src;
}

export function EventHub() {
  //定义一个用来存储回调的对象
  let eventList = {};
  // 事件订阅
  EventHub.prototype.on = function (eventName, callback) {
    //拿到key的值
    let eventCallbacks = eventList[eventName];
    if (eventCallbacks) {
      // 判断是否有注册事件，如果条件成立，说明该事件已经注册过，所以我们可以把函数push进数组中
      eventCallbacks.push(callback);
    } else {
      // 如果没有注册事件以数组的形式存储一份  因为一个事件下面可以注册多个函数
      eventList[eventName] = [callback];
    }
  };
  //事件分发
  EventHub.prototype.emit = function (eventName, data) {
    // 还是拿到key 的值
    let callbacks = eventList[eventName];
    if (callbacks && callbacks.length > 0) {
      // 条件成立之后 通过遍历拿到每个存储的函数
      callbacks.forEach((callback) => callback(data));
    }
  };
  // 事件移除
  EventHub.prototype.off = function (eventName) {
    // 如果传入值为空 移除所有监听事件
    if (typeof eventName === "undefined") {
      eventList = {};
    } else {
      // 移除指定的监听事件
      delete eventList[eventName];
    }
  };
}

export function getAction(value) {
  if (value.constructor === Function) {
    return [value, {}, {}];
  } else {
    return [value.action, value.params, value.headers];
  }
}

/**
 * 简单的 XHR 请求封装
 * @param {Object} options - 请求配置
 * @param {string} options.url - 请求URL
 * @param {string} [options.method='GET'] - 请求方法
 * @param {Object} [options.data] - 请求数据
 * @param {Object} [options.headers] - 请求头
 * @param {number} [options.timeout=10000] - 超时时间(毫秒)
 * @returns {Promise} Promise对象
 */
export function xhrRequest(options) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    // 设置请求方法和URL
    xhr.open(options.method || "GET", options.url, true);

    // 设置超时
    xhr.timeout = options.timeout || 10000;

    // 设置请求头
    if (options.headers) {
      Object.keys(options.headers).forEach((key) => {
        xhr.setRequestHeader(key, options.headers[key]);
      });
    }

    // 请求完成处理
    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          // 尝试解析JSON响应，如果不是JSON则返回原始文本
          const response = xhr.responseText;
          const result = response ? JSON.parse(response) : null;
          resolve(result);
        } catch (e) {
          // 如果不是JSON格式，返回原始文本
          resolve({
            data: xhr.responseText,
            status: xhr.status,
            statusText: xhr.statusText,
          });
        }
      } else {
        reject({
          status: xhr.status,
          statusText: xhr.statusText,
          message: `请求失败: ${xhr.status} ${xhr.statusText}`,
        });
      }
    };

    // 错误处理
    xhr.onerror = function () {
      reject({
        status: 0,
        statusText: "NETWORK_ERROR",
        message: "网络错误",
      });
    };

    // 超时处理
    xhr.ontimeout = function () {
      reject({
        status: 0,
        statusText: "TIMEOUT",
        message: "请求超时",
      });
    };

    // 发送请求数据
    if (options.data) {
      xhr.send(options.data);
    } else {
      xhr.send();
    }
  });
}

// 用a链接导出处理方案GET方式
export async function downloadALink(url, filename) {
  try {
    // 显示下载中状态
    console.log("开始下载文件...");

    // 获取文件
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`下载失败: ${response.status} ${response.statusText}`);
    }

    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    // 创建下载链接
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // 清理URL对象
    setTimeout(() => URL.revokeObjectURL(blobUrl), 100);

    console.log("文件下载完成:", filename);
    return true;
  } catch (error) {
    console.error("下载错误:", error);

    // 降级方案：在新窗口打开
    console.log("使用降级方案...");
    window.open(url, "_blank");
    return false;
  }
}

export const findCenterConfig = (centerId, data) => {
  if (centerId === data.centerId) {
    return null;
  } else {
    if (!Array.isArray(data.relatedCenters)) return;
    const subCenter = data.relatedCenters.find(
      (item) => item.centerId === centerId
    );
    if (!subCenter) return;
    return subCenter.api;
  }
};

export const normalizeUrlSlashes = (url) => {
  // 匹配除了协议://之外的所有双斜杠
  url = url.replace(/([^:])\/\/+/g, "$1/");
  // 去除eventProductApi
  return url.replace("/eventProductApi", "");
};

export const getCenterId = (url) => {
  const queryString = url.split("?")[1];
  return queryString ? new URLSearchParams(queryString).get("centerId") : null;
};
